import React from "react"
import PropTypes from "prop-types"
import styled, { ThemeProvider } from "styled-components"

import { GlobalStyles } from "../../theme/styles/theme"

const theme = {
  breakpoints: {
    xs: "0px",
    custom: "512px",
    sm: "370px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    xxl: "1440px",
  },
}

const Page = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const Layout = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Page id="page">{children}</Page>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
